export const CHART_TYPES = [
  'previous_year',
  'last_12_months',
  'previous_month',
  'last_30_days',
  'yesterday',
  'today'
] as const

export type ChartType = (typeof CHART_TYPES)[number]
